import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './Features.scss';

export default function Features() {
  const { t } = useI18n();
  const items = t('videoGeneration.sora.features.items');
  return (
    <section className="sora2-features">
      <div className="sora2-features__inner">
        <h2>{t('videoGeneration.sora.features.title')}</h2>
        <p className="sora2-features__sub">{t('videoGeneration.sora.features.sub')}</p>
        <div className="sora2-features__grid">
          {items.map((i) => (
            <div key={i.num} className="sora2-feature">
              <div className="sora2-feature__num">{i.num}</div>
              <h3>{i.title}</h3>
              <p>{i.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}